<script>
import twButtonsMixin from '@/mixins/twButtonsMixin.js'
import twUploadFieldMixin from '@/mixins/twUploadFieldMixin.js'
import { ArrowUpTrayIcon } from '@heroicons/vue/16/solid'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwButton from '@/components/generic/tw-button.vue'


export default {
  name: "TwUploadField",
  components: { ArrowUpTrayIcon, TwButton },
  mixins:[twButtonsMixin, twUploadFieldMixin],
  computed: {
    twIconClasses() {
      return [
        {'h-4' : this.size === 'default'},
        {'h-3' : this.size === 'sm'},
        {'h-4' : this.size === 'lg'},
        {'h-5' : this.size === 'xl'},
      ]
    },
    twClasses() {
      return [
        {'min-w-48': this.LoadingUploading},
        'btn',
        'transition ease-in-out duration-500',
        'btn-variant-' + this.variant,
        'btn-size-' + this.size,
        {'btn-pill': this.pill},
        {'btn-block': this.block}
      ];
    },
    loadingClasses() {
      return [
        'animate-spin',
        {'h-4 w-4' : this.size === 'default'},
        {'h-3 w-3' : this.size === 'sm'},
        {'h-6 w-6' : this.size === 'lg'},
        {'h-7 w-7' : this.size === 'xl'},
        'transition-all',
        'ease-in-out',
        'duration-500',
        {'text-black': ['secondary','upload'].indexOf(this.variant) > -1},
        {'text-blue': ['primary'].indexOf(this.variant) > -1},
        {'text-white': ['warning','danger','info'].indexOf(this.variant) > -1}
      ];
    }
  }
}
</script>

<template>
  <tw-button :disabled="disabled || LoadingUploading" type="button" block size="sm" variant="upload" :icon="!LoadingUploading? 'upload':null" class="w-auto" @click="$refs.uploadableField.click()">
    <icon v-show="LoadingUploading" spin icon="cog" />
    <span v-if="LoadingUploading"> {{ UploadPercentage }}% </span>
    <slot>
      <span v-if="LoadingUploading && UploadPercentage === 100"> Processing... </span>
      <span v-else-if="LoadingUploading"> Uploading </span>
      <span v-else> Upload </span>
    </slot>
    <input id="uploadableField" ref="uploadableField" :accept="accept" :multiple="multiple" class="hidden" type="file" name="uploadableField" @change="syncFile()">
  </tw-button>
</template>

<style scoped>

</style>
